// btw-front/src/components/admin/dashboard/SignupRejectModal.jsx
// [파트너 가입 신청] 반려 사유 입력 팝업
// props 는 SignupsTab 의 상태/핸들러 이름을 그대로 받는다(부모 식별자와 1:1).
import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { Textarea } from "../../ui/Textarea";

export default function SignupRejectModal({
  acting,
  handleReject,
  rejectOpen,
  rejectReason,
  setRejectOpen,
  setRejectReason,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        title={t("admin.signup.confirmReject")}
        open={rejectOpen}
        onCancel={() => setRejectOpen(false)}
        onOk={handleReject}
        confirmLoading={acting}
        okText={t("admin.signup.reject")}
        cancelText={t("partners.deals.detail.cancel")}
      >
        <Textarea
          label={t("admin.signup.rejectReasonLabel")}
          rows={4}
          maxLength={500}
          placeholder={t("admin.signup.rejectReasonPlaceholder")}
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
    </>
  );
}
